export enum ContactRelatedProduct {
  NDAPP = 'ndapp',
  GASBOT = 'gasbot',
}
